

import templateProductCard from '@/app-template/lib/components/ProductCard.vue';

export default {
  components: { templateProductCard },
};
